import { render } from "./Game.vue?vue&type=template&id=5575a6e6&scoped=true&ts=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=5575a6e6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5575a6e6"]])

export default __exports__